"use strict";

angular.module("licensure.services").factory("EXPackets", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamPackets", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamPackets/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getPassingRequirments: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/PassingRequirments/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            newPassingRequirment: function (newName, minCount, id) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/ExamModule/PassingRequirment/";

                $http({
                    method: method,
                    url: url,
                    data: {
                            name: newName,
                            minPassedForms: minCount,
                            examPacketId: id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        if (response.data.exceptionMessage.indexOf("UNIQUE KEY constraint") > 0)
                            d.resolve({ error: "A Group already exists with that name." })
                        else
                            d.resolve({ error: "An error has occurred.  Please contact support." })
                        // handle error
                    });

                return d.promise;
            },

            save: function (exam_packet) {
                var d = $q.defer();
                var method = "POST";
                var url = apiLocation + "/api/ExamModule/ExamPackets/";

                if (!isUndefined(exam_packet.id)) {
                    method = "PUT";
                    url += exam_packet.id;
                }
                $http({
                    method: method,
                    url: url,
                    data: {
                        name: exam_packet.name,
                        id: exam_packet.id,
                        active: exam_packet.active,
                        description: exam_packet.description,
                        maxFailedAttempts: exam_packet.maxFailedAttempts,
                        activeStatus: exam_packet.activeStatus,
                        ExamPacketForms: exam_packet.examPacketForms,
                        licenseCategoryLevelId: exam_packet.licenseCategoryLevelId,
                        ExamPacketPassingRequirementGroups: exam_packet.passingRequirments 
                    }
                })
                    .then(function (response) {
                        var returnID = response.data.id;
                        if (!isUndefined(exam_packet.id))
                            returnID = exam_packet.id;

                        d.resolve({ id: returnID});
                    })
                    .catch(function (response) {
                        if (response.data.exceptionMessage.indexOf('insert duplicate key row in object') > 0) {
                            d.resolve({ id: null, message: "There is already a packet with that name.  Please user a different packet name." });
                        }
                        else
                            d.resolve({ id: null, message: "There was an issue saving your packet.  Please contact support: " + response.data.exceptionType });
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/ExamModule/ExamPackets/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            updateStatuses: function (packets, status) {
                var d = $q.defer();
                $http
                    .post(
                        apiLocation + "/api/ExamModule/ExamPackets/UpdateStatuses/",
                        {
                            examPacketIDs: packets,
                            status: status
                        }
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            copy: function (id) {
                var d = $q.defer();

                $http
                    .post(apiLocation + "/api/ExamModule/CopyExamPacket/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        if (response.data.errorMessage.indexOf('insert duplicate key row in object') > 0) {
                            d.resolve({ id: null, message: "Issue copying the current packet.  There is already a packet with the name:" });
                        }
                        d.resolve({ id: response.data.id, message: "Record copied successfully" });
                    })
                    .catch(function (response) {
                        if (response.data.errorMessage.indexOf('insert duplicate key row in object') > 0) {
                            d.resolve({ id: null, message: "Issue copying the current packet.  There is already a packet with the name:" });
                        }
                        else
                            d.resolve({ id: null, message: "There was an issue saving your packet.  Please contact support: " + response.data.exceptionType });
                    });

                return d.promise;
            },

        };
    }
]);
